//Import Vue Select
import {OpenIndicator} from './open-indicator.js'
import vSelect from 'vue-select'
vSelect.props.components.default = () => ({ OpenIndicator });


export const CaseListing = {
    components: {
		vSelect
	},
    data: () => ({
		selectedCategory: [],
		sortBy: 'deadline',
	}),

	computed: {
        orderedCases: function() {
			let dir = 'desc'

			switch(this.sortBy) {
				case 'deadline':
					dir = 'desc'
					break;
				case 'title':
					dir = 'asc'
					break;
				default:
					dir = 'desc'
			}

			return _.orderBy(this.content.cases,this.sortBy,dir)
		},
		cases: function() {
			return this.orderedCases.filter(item => {
				if(!this.selectedCategory.length){
					return item
				}

				if (this.selectedCategory.some(r=> item.categories.includes(r))) {
					return item
				}
			});
		},
	}
};



// WEBPACK FOOTER //
// ./assets/_js/mixins/case-listing.js